<template>
  <!-- Page Content -->
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-cogs fa-fw"></i> Configurações
          </h1>
          <div class="panel panel-default">
            <div class="panel panel-heading">
              Editar Configurações do sistema
            </div>
            <div class="panel panel-body">
              <form @submit.prevent="update">
                <div class="form-group">
                  <label>Nome do Sistema</label>
                  <input class="form-control" v-model="configuration.name" />
                </div>
                <div class="form-group">
                  <label>Email</label>
                  <input class="form-control" v-model="configuration.email" />
                </div>
                <div class="form-group">
                  <label>Dias para informar o termino da validade</label>
                  <input class="form-control" v-model="configuration.daysForNotifyValidity" />
                </div>
                <div class="form-group">
                  <label>Versão API</label>
                  <input class="form-control" v-model="configuration.version" disabled />
                </div>
                <div class="form-group">
                  <label>Data API</label>
                  <input class="form-control" :value="configuration.versionDate | formatDate" disabled />
                </div>
                <div class="form-group">
                  <label>Data atual servidor</label>
                  <input class="form-control" :value="configuration.currentDate | formatDate" disabled />
                </div>
                <div class="form-group">
                  <label> Setor administrador (pode emitir, remover certificados e remover acreditações) </label>
                  <select class="form-control" v-model="configuration.sectorId" required>
                    <option disabled>Escolha um Setor</option>
                    <option v-for="sector in sectors" :key="sector.id" v-bind:value="sector.id">
                      {{ sector.name }}
                    </option>
                  </select>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="check-hab"
                    v-model="configuration.allowAdminsManageFiles" :checked="configuration.allowAdminsManageFiles" />
                  <label class="form-check-label" for="check-hab">
                    Permitir setor administrador ver documentos de outros setores
                  </label>
                </div>
                <br />
                <div class="row">
                  <div class="col-md-12">
                    <label>Ultima versão do procedimento PC57</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-group">
                      <file-pond name="file" ref="pond" label-idle="Coloque a ultima versão do procedimento aqui"
                        v-bind:allow-multiple="false" accepted-file-types="application/pdf" v-bind:server="server"
                        v-on:init="handleFilePondInit" />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <a class="btn btn-default btn-small btn-block" download="download" v-bind:href="download"> <i
                        class="fa fa-download fa-fw"></i> download</a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label>Manual PassaPort</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-group">
                      <file-pond name="file" ref="pond" label-idle="Coloque a ultima versão do Manual PassaPort aqui"
                        v-bind:allow-multiple="false" accepted-file-types="application/pdf" v-bind:server="serverManual"
                        v-on:init="handleFilePondInit" />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <a class="btn btn-default btn-small btn-block" download="download" v-bind:href="downloadManual"> <i
                        class="fa fa-download fa-fw"></i> download</a>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label>Termo de Responsabilidade</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-group">
                      <file-pond name="file" ref="pond" label-idle="Coloque o Termo de Responsabilidade aqui"
                        v-bind:allow-multiple="false" accepted-file-types="application/pdf" v-bind:server="serverTermo"
                        v-on:init="handleFilePondInit" />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <a class="btn btn-default btn-small btn-block" download="download" v-bind:href="downloadTermo"> <i
                        class="fa fa-download fa-fw"></i> download</a>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label>Formulário para empresas de retirada de resíduo de bordo</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10">
                    <div class="form-group">
                      <file-pond name="file" ref="pond" label-idle="Coloque o Formulário para empresas de retirada de resíduo de bordo aqui"
                        v-bind:allow-multiple="false" accepted-file-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" v-bind:server="serverFormulario"
                        v-on:init="handleFilePondInit" />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <a class="btn btn-default btn-small btn-block" download="download" v-bind:href="downloadFormulario"> <i
                        class="fa fa-download fa-fw"></i> download</a>
                  </div>
                </div>

                <br>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <button type="submit" class="btn btn-success btn-block">
                        <i class="fa fa-send fa-fw"></i> Atualizar
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>
</template>

<script>
import vueFilePond, { setOptions } from "vue-filepond";

import ptBR from "filepond/locale/pt-br";
import "filepond/dist/filepond.css";
import storage from '../../mixins/storage'

const FilePond = vueFilePond();

setOptions(ptBR);

export default {
  components: { FilePond },
  name: "Configurations",
  inject: ["loading"],
  data() {
    return {
      sector: {},
      sectors: [],
      configuration: {},
      files: [
        {
          source: "12345",
          options: {
            type: "local",
            file: {
              name: `${this.$http.defaults.baseURL}/public/download-procedimento-pc-57`,
              size: 3001025,
              type: "application/pdf",
            },
          },
        },
      ],
      server: {
        url: this.$http.defaults.baseURL,
        process: {
          url: "/config/upload",
          method: "POST",
          withCredentials: false,
          headers: {
            Authorization:
              `Bearer ${storage.methods.getToken()}`,
          },
          timeout: 7000,
          onload: null,
          onerror: null,
          ondata: null,
        },
      },
      serverTermo: {
        url: this.$http.defaults.baseURL,
        process: {
          url: "/config/upload-termo",
          method: "POST",
          withCredentials: false,
          headers: {
            Authorization:
              `Bearer ${storage.methods.getToken()}`,
          },
          timeout: 7000,
          onload: null,
          onerror: null,
          ondata: null,
        },
      },
      serverManual: {
        url: this.$http.defaults.baseURL,
        process: {
          url: "/config/upload-manual",
          method: "POST",
          withCredentials: false,
          headers: {
            Authorization:
              `Bearer ${storage.methods.getToken()}`,
          },
          timeout: 7000,
          onload: null,
          onerror: null,
          ondata: null,
        },
      },
      serverFormulario: {
        url: this.$http.defaults.baseURL,
        process: {
          url: "/config/upload-formulario",
          method: "POST",
          withCredentials: false,
          headers: {
            Authorization:
              `Bearer ${storage.methods.getToken()}`,
          },
          timeout: 7000,
          onload: null,
          onerror: null,
          ondata: null,
        },
      }
    };
  },
  computed: {

    download() {
      return `${this.$http.defaults.baseURL}/public/download-procedimento-pc-57`
    },
    downloadTermo() {
      return `${this.$http.defaults.baseURL}/public/download-termo`
    },
    downloadManual() {
      return `${this.$http.defaults.baseURL}/public/download-manual`
    },
    downloadFormulario() {
      return `${this.$http.defaults.baseURL}/public/download-formulario`
    }

  },
  methods: {
    update() {
      this.loading.value = true;
      this.$http.put("/config", this.configuration).then((response) => {
        this.configuration = response.data;
      });
      setTimeout(() => this.loading.value = false, 1000)
    },
    handleFilePondInit() {
      console.log("A funcao handleFilePondInit foi iniciada...");
    }
  },
  mounted() {
    this.loading.value = true;
    this.$http.get("/config").then((response) => {
      this.configuration = response.data;
    })
    this.$http.get("sector").then((response) => {
      this.sectors = response.data.content;
    });
    setTimeout(() => this.loading.value = false, 1000)
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/Configurations.vue